import { useEffect, useState, useLayoutEffect, useRef } from "react";
const ModalHeader = ({ children, onClose }) => {
  return (
    <div
      style={{
        padding: '16px 20px',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
        {children}
      </h2>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          fontSize: '24px',
          cursor: 'pointer',
          color: '#6b7280',
          padding: '0',
          width: '30px',
          height: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        ×
      </button>
    </div>
  );
};

export default ModalHeader;
